<template>
  <div class="investment-checkout">

    <!-- 金额 倒计时 -->
    <div class="amount-card">
      <div class="amount-line1">Amount</div>
      <div class="amount-line2">
        <span class="currency">NPR</span>
        <span class="amount-value">{{ orderInfo.amount }}</span>
      </div>
      <div class="amount-line3">
        <img src="@/assets/v4/time.png" alt="Time Icon" class="time-icon" />
        <span class="time-label"> </span>
        <span class="time-countdown">
          <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" class="timer1" />
        </span>
      </div>
    </div>

    <!-- 银行信息区域 -->
    <div class="panel-card">
      <div class="section-header">
        <img src="@/assets/v4/bank-card.png" alt="Bank Icon" class="section-icon" />
        <span class="section-title">Bank Information</span>
        <div class="top-right-logo">
          <img src="@/assets/v4/logo2.png" alt="Logo" class="logo-img" loading="lazy" />
        </div>
      </div>
      <!-- Bank Name 区域 -->
      <div class="info-group">
        <div class="info-label-row">
          <img src="@/assets/v4/bank.png" alt="Bank Icon" class="info-icon" />
          <span class="info-label">Bank Name:</span>
        </div>
        <div class="info-input-row">
          <input type="text" class="info-input" :value="orderInfo.recBank" disabled :class="{ copied: copyBankIf }" />
          <button @click="copyBank" class="copy-btn">
            <img src="@/assets/v4/copyWhite.png" alt="Copy" class="copy-icon" />
          </button>
        </div>
      </div>
      <!-- Account Number 区域 -->
      <div class="info-group">
        <div class="info-label-row">
          <img src="@/assets/v4/bank-card.png" alt="Card Icon" class="info-icon" />
          <span class="info-label">Account Number:</span>
        </div>
        <div class="info-input-row">
          <input type="text" class="info-input" :value="orderInfo.recCardNo" disabled :class="{ copied: copyCardNoIf }" />
          <button @click="copyCardNo" class="copy-btn">
            <img src="@/assets/v4/copyWhite.png" alt="Copy" class="copy-icon" />
          </button>
        </div>
      </div>
      <!-- Account Name 区域 -->
      <div class="info-group">
        <div class="info-label-row">
          <img src="@/assets/v4/user.png" alt="User Icon" class="info-icon" />
          <span class="info-label">Account Name:</span>
        </div>
        <div class="info-input-row">
          <input type="text" class="info-input" :value="orderInfo.recOwner" disabled :class="{ copied: copyOwnerIf }" />
          <button @click="copyOwner" class="copy-btn">
            <img src="@/assets/v4/copyWhite.png" alt="Copy" class="copy-icon" />
          </button>
        </div>
      </div>
    </div>

    <!-- 支付信息区域-->
    <div class="panel-card payment-panel">
      <!-- <div class="section-header">
        <img src="@/assets/v4/money.png" alt="Payment Icon" class="section-icon" />
        <span class="section-title">Payment Information</span>
      </div> -->
      <div class="payment-voucher">
        <div class="voucher-label-row">
          <span class="voucher-label">Please make payment according to the amount displayed on the recharge interface.</span>
        </div>
        <!-- <div class="voucher-label-row">
          <img src="@/assets/v4/payment.png" alt="Voucher Icon" class="voucher-icon" />
          <span class="voucher-label">Payment Voucher:</span>
        </div> -->
        <!-- <div class="upload-area">
          <div class="upload-icon-wrapper">
            <img src="@/assets/v4/upload.png" alt="Upload" class="upload-icon" />
          </div>
          <p>Click to upload payment proof, or simply drag the image here.</p>
          <input ref="file1" type="file" name="file1" class="file-input" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="fileSelected">
          <button class="upload-btn" @click="fileOpen">
            Upload
          </button>
        </div> -->
      </div>
    </div>

    <div class="hidden-sections" style="display: none;">
      <!-- 二维码区域  先隐藏-->
      <div class="qr-card" v-if="recQrUrlImg">
        <h4>Alternative Payment: Scan QR Code</h4>
        <div class="qr-container">
          <div class="qr-image-wrapper">
            <img :src="recQrUrlImg" class="qr-img" />
          </div>
          <div class="qr-steps">
            <div class="step-item qr-step">
              <div class="step-number">1</div>
              <div class="step-desc">Download and save the QR code image</div>
            </div>
            <div class="step-item qr-step">
              <div class="step-number">2</div>
              <div class="step-desc">Use APP to scan QR code and pay</div>
            </div>
            <a class="action-btn download-btn" :href="recQrUrlImg" :download="`${orderInfo.orderId}-${orderInfo.amount}.png`">
              Download
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹出确认框 -->
    <div class="modal" v-if="showMsg1">
      <div class="modal-content">
        <div style="font-size: 0.95em;" v-if="showMsg1Over">{{ showMsg1Txt }}</div>
        <div style="font-size: 0.95em;" v-else>Please Wait ...</div>
        <button class="action-btn modal-close" @click="rcodeClose" v-if="showMsg1Over">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
// 原有script代码完全保留
import * as apis from "@/apis/apis";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import QRCode from "qrcode";

export default {
  components: {
    TimerComp2,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      copyBankIf: false,
      copyOwnerIf: false,
      copyCardNoIf: false,
      copyAmountIf: false,
      recQrUrlImg: "",
      rcode: "",
      showMsg1: false,
      showMsg1Txt: "Operation successful",
      showMsg1Over: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.rcode = this.orderInfo.tranMark;
      if (this.orderInfo.recQrUrl) {
        QRCode.toDataURL(
          this.orderInfo.recQrUrl,
          { errorCorrectionLevel: "L", margin: 1, width: 500 },
          (_, url) => {
            if (!url) return;
            this.recQrUrlImg = url;
          }
        );
      }
    },
    copyBank: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recBank,
        1,
        () => {
          this.copyBankIf = true;
          setTimeout(() => {
            this.copyBankIf = false;
          }, 3000);
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    copyOwner: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recOwner,
        1,
        () => {
          this.copyOwnerIf = true;
          setTimeout(() => {
            this.copyOwnerIf = false;
          }, 3000);
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    copyCardNo: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recCardNo,
        1,
        () => {
          this.copyCardNoIf = true;
          setTimeout(() => {
            this.copyCardNoIf = false;
          }, 3000);
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    copyAmount: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.copyAmountIf = true;
          setTimeout(() => {
            this.copyAmountIf = false;
          }, 3000);
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    rcodeSubmit() {
      this.showMsg1 = true;
      this.showMsg1Over = false;
      apis
        .bkcd_np_rcode({
          id: this.orderInfo.orderId,
          rcode: this.rcode,
        })
        .then(() => {
          this.showMsg1Txt = "Reference Code submitted successfully！";
          this.showMsg1Over = true;
        });
    },
    rcodeClose() {
      this.showMsg1 = false;
      this.showMsg1Over = false;
    },
    fileOpen() {
      this.$refs.file1.click();
    },
    fileSelected(event) {
      let that = this;
      const files = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (event) => {
        var img = new Image();
        img.src = event.target.result;
        img.onload = function () {
          let maxSize = 800;
          let width = img.width;
          let height = img.height;
          if (width > height) {
            height = maxSize * (height / width);
            width = maxSize;
          } else {
            width = maxSize * (width / height);
            height = maxSize;
          }
          var canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(this, 0, 0, width, height);
          var dataUrl = canvas.toDataURL("image/jpeg", 0.3);
          that.showMsg1 = true;
          that.showMsg1Over = false;
          apis
            .bkcd_np_cimg({
              id: that.orderInfo.orderId,
              cimg: dataUrl,
            })
            .then(() => {
              //上传成功后的弹出信息
              that.showMsg1Txt = "Image uploaded successfully!";
              that.showMsg1Over = true;
              //本业务上传成功后，调用同步跳转
              that.$parent.$parent.redirectUrl();
            });
        };
      };
    },
  },
};
</script>

<style>
</style>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.investment-checkout {
  font-family: "Segoe UI", Roboto, Oxygen, sans-serif;
  background-color: #f0f2f5;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;

  // 金额卡片（分三行居中显示）
  .amount-card {
    background-color: #88cc5d; //
    color: white;
    padding: 1.5rem 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
    text-align: center;
    position: relative;
    margin-top: 1rem;

    .amount-line1 {
      font-size: 1rem;
      opacity: 0.9;
      margin-bottom: 0.5rem;
    }
    .amount-line2 {
      font-size: 1.8rem;
      font-weight: 600;
      margin-bottom: 0.8rem;
      .currency {
        margin-right: 0.5rem;
      }
    }

    .amount-line3 {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      font-size: 0.9rem;
      background-color: rgba(255, 255, 255, 0.3);
      padding: 0.4rem 1rem;
      border-radius: 16px;
      width: fit-content;
      margin: 0 auto;
      position: relative;

      @media (min-width: 769px) {
        .time-icon {
          width: 36px !important;
          height: 36px !important;
          transform: translateY(0) !important;
        }
      }

      @media (max-width: 768px) {
        .time-icon {
          width: 20px !important;
          height: 20px !important;
          object-fit: contain;
          filter: none;
          transform: translateY(-2px) !important;
        }

        .time-countdown {
          font-weight: 500;
          color: #591fa5 !important;
          padding-top: 3px !important;
          margin-bottom: -3px !important;
          display: inline-block !important;

          .timer1 {
            .pay-time {
              margin-bottom: 0 !important;
              line-height: 1 !important;
              padding-top: 3px !important;
              display: inline-block !important;
            }
          }
        }
      }

      .time-countdown {
        font-weight: 500;
        color: #591fa5 !important;
      }
      .timer1 .pay-time {
        margin-bottom: 0 !important;
      }
    }
  }

  .panel-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    margin-bottom: 1rem;

    .section-header {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 1rem;
      color: #88cc5d;
      font-weight: 600;
      .section-icon {
        width: 30px;
        height: 30px;
        object-fit: contain;
      }
      .top-right-logo {
        position: absolute;
        right: 0.5em;
        .logo-img {
          height: 2em;
          object-fit: contain;
        }
      }
    }

    .info-group {
      margin-bottom: 1rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .info-label-row {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.3rem;
      color: #6b7280;
      font-size: 0.9rem;

      .info-icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
    }

    .info-input-row {
      display: flex;
      align-items: center;
      gap: 0;
      position: relative;
      .info-input {
        flex: 1;
        padding: 0.6rem;
        border: 1px solid #d1d5db;
        border-right: none;
        border-radius: 4px 0 0 4px;
        background-color: #f9fafb;
        color: #1f2937;
        cursor: not-allowed;
        position: relative;

        &.copied {
          border-color: #00b42a;
          border-right: none;
          &::after {
            content: "✓ Copied";
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            color: #00b42a;
            font-size: 0.7rem;
            font-weight: 500;
            background-color: #f0fdf4;
            padding: 2px 8px;
            border-radius: 12px;
          }
        }
      }
      .copy-btn {
        background-color: #88cc5d;
        border: none;
        padding: 0.6rem;
        cursor: pointer;
        border-radius: 0 4px 4px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 100%;
        &:active {
          background-color: #77bb4c; // 点击时加深颜色
        }

        .copy-icon {
          width: 20px;
          height: 20px;
          object-fit: contain;
        }
      }
    }
  }

  // 支付信息面板
  .payment-panel {
    .reference-code-section {
      margin-bottom: 1rem;
      .step-guide {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 0.8rem;
        gap: 0.5rem;
        .step-item {
          flex: 1;
          text-align: center;
          .step-number {
            width: 1.8rem;
            height: 1.8rem;
            background-color: #88cc5d;
            color: white;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.3rem;
            font-weight: 600;
            font-size: 0.8rem;
          }
          .step-desc {
            color: #4b5563;
            font-size: 0.8rem;
          }
        }
      }

      .input-group {
        display: flex;
        gap: 0.5rem;
        width: 100%;
        .ref-input {
          flex: 1;
          padding: 0.6rem;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          font-size: 0.9rem;
          min-width: 0;
        }
        .submit-btn {
          padding: 0.6rem 1rem;
          white-space: nowrap;
          background-color: #88cc5d;
          color: white;
          border: none;
          border-radius: 4px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;
          font-size: 0.9rem;
        }
      }
    }
    .payment-voucher {
      .voucher-label-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.8rem;
        color: #6b7280;
        font-size: 0.9rem;

        .voucher-icon {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }
      }
      .upload-area {
        border: 2px dashed #88cc5d;
        border-radius: 8px;
        padding: 2rem 1rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .upload-icon-wrapper {
          text-align: center;
          margin: 0 auto 0.8rem;
        }
        .upload-icon {
          width: 40px;
          height: 40px;
          object-fit: contain;
          display: inline-block;
        }
        p {
          color: #6b7280;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }
        .upload-btn {
          background-color: #88cc5d;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 0.5rem 1rem;
          font-size: 0.9rem;
          cursor: pointer;
          transition: background-color 0.2s;
          width: fit-content;
        }
      }
    }
  }

  // 弹窗样式
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .modal-content {
      background-color: white;
      padding: 1.2rem;
      border-radius: 8px;
      width: 90%;
      max-width: 300px;
      text-align: center;
    }

    .modal-close {
      background-color: #88cc5d;
      color: white;
      padding: 0.5rem 1.5rem;
      border: none;
      border-radius: 6px;
      font-weight: 500;
      cursor: pointer;
      font-size: 0.9rem;
      margin-top: 1rem;
    }
  }

  // 隐藏元素
  .file-input {
    display: none;
  }
  .hidden-sections {
    display: none;
  }
}
</style>